import styled from 'styled-components';
import { Icon } from '../../../iconsHelper';
const displayContainerStyles = ({ isVisible, displayedFromLeftSide }) => {
    if (displayedFromLeftSide) {
        return `
      left: ${isVisible ? '0' : '-100vw'};
      transition: left 0.3s ease;
    `;
    }
    return `
    right: ${isVisible ? '0' : '-100vw'};
    transition: right 0.3s ease;
  `;
};
export const Container = styled.li `
  display: block;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  height: 100vh;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;

  ${({ isVisible, displayedFromLeftSide }) => displayContainerStyles({ isVisible, displayedFromLeftSide })};
`;
export const Header = styled.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 20px 15px 20px 15px;
`;
export const Title = styled.h2 `
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSizes.sizeMd4};
  line-height: 32px;
`;
export const CloseButton = styled.button `
  border: none;
  background: none;
  padding: 0;
  color: ${({ theme }) => theme.colorsV2.font.textPrimary};
`;
export const StyledIcon = styled(Icon) `
  width: 22px;
  height: 22px;
  color: ${({ theme }) => theme.colorsV2.font.textPrimary};
`;
export const ComeBack = styled(CloseButton) `
  display: flex;
`;
export const ChildrenWrapper = styled.div `
  padding: 0 15px 30px;
`;
//# sourceMappingURL=MobileNavigationTemplate.styled.js.map